<script>
    import { Router, navigateTo } from 'svelte-router-spa'
    import { routes } from './routes';

    // Konami Code to get to Admin Portal
    var pattern = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'];
    var current = 0;

    // Listen for keydown events
    document.addEventListener('keydown', () => {
        if (pattern.indexOf(event.key) < 0 || event.key !== pattern[current]) {
            current = 0;
            return;
        }
        current++;
        if (pattern.length === current) {
            current = 0;
            navigateTo('admin');
        }
    }, false);

    // Refresh User Data
	import { onMount } from 'svelte';
	import { fade } from 'svelte/transition';
	import { db } from './api.js';
    let api = {
        player: {},
        players: [],
        shops: [],
        places: [],
        paths: [],
        blank: {
            shop: {},
            place: {},
            path: {},
        },
        icons: {
            'Road': '/assets/icon/road.svg',
            'Rail': '/assets/icon/train.svg',
            'Portal': '/assets/icon/portal.png',
            'Overworld': '/assets/icon/road.svg',
            'Nether': '/assets/icon/portal.png'
        },
        ready: false
    }, loading = true, loadingProgress = 0, loadingNote = 'Loading...';

    function sleep(s) {
        return new Promise(resolve => setTimeout(resolve, (s * 1000)));s
    };

    onMount(async () => {
        if (window.localStorage.getItem('refresh_token')) {
            if (JSON.parse(window.localStorage.getItem('user')).username == undefined) {
                window.localStorage.setItem('refresh_token', '');
                window.localStorage.setItem('user', '');
            }

            // Get access and refresh tokens

            var urlencoded = new URLSearchParams();
            urlencoded.append('client_id', '834733070522777680');
            urlencoded.append('client_secret', '5rEP-nGcEmbcvUqVuHe6mjTISod18suY');
            urlencoded.append('grant_type', 'refresh_token');
            urlencoded.append('refresh_token', window.localStorage.getItem('refresh_token'));

            var auth = await fetch('https://discord.com/api/oauth2/token', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: urlencoded
            }).then(res => {
                return res.json()
            });

            window.localStorage.setItem('refresh_token', auth.refresh_token);
            window.localStorage.setItem('access_token', auth.access_token);

            // Get user from access tokens

            var user = await fetch('https://discord.com/api/users/@me', {
                method: 'GET',
                headers: {
                    'Authorization': 'Bearer ' + auth.access_token
                }
            }).then(res => {
                return res.json()
            });

            window.localStorage.setItem('user', JSON.stringify(user));

            // Get Pages DB User

            let players = await fetch('https://api.phoenix-pages.izmichael.com/players', {
                headers: {
                    'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8'
                }
            }).then(res => {return res.json()});

            let player = players.filter(a => a.PlayerDiscord == user.id)[0];
            window.localStorage.setItem('player', JSON.stringify(player));
        };
    
        // API

        loadingNote = 'Blending Colours...';
        loadingProgress = 0;

        loadingNote = 'Loading Discord...';
        api.player = JSON.parse(window.localStorage.getItem('player') || '{}');
        loadingProgress = 10;
            
        // loadingNote = 'Fetching Player List...';
        // api.players = await fetch('https://api.phoenix-pages.izmichael.com/players', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 20;

        // loadingNote = 'Fetching Shop List...';
        // api.shops = await fetch('https://api.phoenix-pages.izmichael.com/shops/', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 30;

        // loadingNote = 'Fetching Place List...';
        // api.places = await fetch('https://api.phoenix-pages.izmichael.com/places/', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 40;

        // loadingNote = 'Fetching Paths...';
        // api.paths = await fetch('https://api.phoenix-pages.izmichael.com/paths/', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 50;
        
        // // Blanks
        // loadingNote = 'Mapping the Road Networks...';
        // api.blank.shop = await fetch('https://api.phoenix-pages.izmichael.com/blank/shop/', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 60;

        // loadingNote = 'Calculating Distances...';
        // api.blank.place = await fetch('https://api.phoenix-pages.izmichael.com/blank/place/', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 70;

        // loadingNote = 'Loading Images...';
        // api.blank.path = await fetch('https://api.phoenix-pages.izmichael.com/blank/path/', {
        //     headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
        // }).then(res => {return res.json()});
        // loadingProgress = 80;

        loadingNote = 'Fetching the Database...';
        let urls = [
            'https://api.phoenix-pages.izmichael.com/players',
            'https://api.phoenix-pages.izmichael.com/shops',
            'https://api.phoenix-pages.izmichael.com/places',
            'https://api.phoenix-pages.izmichael.com/paths',
            'https://api.phoenix-pages.izmichael.com/blank/shop',
            'https://api.phoenix-pages.izmichael.com/blank/place',
            'https://api.phoenix-pages.izmichael.com/blank/path'
        ]
        let datas = await Promise.all(urls.map(async url => {
            const res = await fetch(url, {
                headers: { 'Authorization': 'iIZti8qsxy3cPs0MMrIz0aYtqIOrhjPi8' }
            });
            loadingProgress += 10;
            return res.json();
        }));
        api.players = datas[0];
        api.shops = datas[1];
        api.places = datas[2];
        api.paths = datas[3];
        api.blank.shop = datas[4];
        api.blank.place = datas[5];
        api.blank.path = datas[6];

        loadingNote = 'Sorting the Lists...';
        api.shops.sort((a, b) => (a.ShopName.toUpperCase() > b.ShopName.toUpperCase()) ? 1 : -1);
        api.places.sort((a, b) => (a.PlaceName.toUpperCase() > b.PlaceName.toUpperCase()) ? 1 : -1);
        api.paths.sort((a, b) => (a.PathName.toUpperCase() > b.PathName.toUpperCase()) ? 1 : -1);
        for (let i = 0; i < api.shops.length; i++) {
            api.shops[i].ShopProducts.sort((a, b) => (a.item.toUpperCase() > b.item.toUpperCase()) ? 1 : -1);
        };
        loadingProgress = 90;

        api.ready = true;
        db.set(api);
        loadingProgress = 100;
        loadingNote = 'Loading Complete. Welcome!';
        await sleep(1)
        loading = false;
    });

    import { SvelteToast } from '@zerodevx/svelte-toast';
    const options = {
        duration: 4000,       // duration of progress bar tween to the `next` value
        initial: 1,           // initial progress bar value
        next: 0,              // next progress value
        pausable: false,      // pause progress bar tween on mouse hover
        dismissable: true,    // allow dismiss with close button
        reversed: false,      // insert new toast to bottom of stack
        intro: { x: 256 },    // toast intro fly animation settings
        theme: {},            // css var overrides
        classes: ['toast']    // user-defined classes
    };
</script>

<SvelteToast {options} />

{#if loading == true}
    <style>    
        #loadingElement {       
            background-image: url('/assets/img/Loader.gif');
            background-position: center;
            background-size: cover;
            position: relative;
        }
        #loadingElement::before { 
            backdrop-filter: blur(2px);
            position: absolute;
            inset: 0 0 0 0;
            width: 100%;
            height: 100%;
            content: '';
            z-index: 1001;
            background-color: rgb(228 228 228 / 15%);
            /* background-color: rgb(0, 0, 255); */
        }
        
        #loadingScreen {
            background-color: rgba(255, 255, 255, .15);  
            backdrop-filter: blur(5px);
        }
    </style>
    <div id="loadingScreen" class="w-screen h-screen z-[1000] flex flex-col justify-center items-center absolute top-0 left-0 select-none" out:fade>
        <div id="loadingElement" class="aspect-square shadow-elevate-xl border-brand flex flex-col items-center justify-center w-1/3 p-5 bg-white border-4">
            <div id="loadingContent" class="z-[1002] w-full flex flex-col justify-center items-center">
                <h1 class="h-9 mb-3 text-3xl font-bold text-center text-white">{loadingNote}</h1>
                <div class="flex flex-row items-center justify-start w-1/3 mb-1 overflow-hidden bg-gray-200 rounded-full">
                    <span class="bg-brand transition-[width] duration-400 ease-linear h-4" style="width: {loadingProgress}%;"></span>
                </div>
            </div>
        </div>
    </div>
{/if}

<Router {routes}/>

<style global>
    @tailwind base;
    @tailwind components;
    @tailwind utilities;

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1; 
    }
    
    ::-webkit-scrollbar-thumb {
        background: #888; 
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555; 
    }

    * {
        outline: none;
    }

    /* a[href^="http://"], 
    a[href^="https://"] {
        background: url('/assets/icon/external.svg') center right no-repeat;
        padding-right: 1.5rem;
    } */

    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Toasts */
    .toast.success {
        --toastBackground: #39db7f;
    }

    .toast.warning {
        --toastBackground: #FFC500;
    }

    .toast.danger {
        --toastBackground: #D81A1A;
    }

    .toast.info {
        --toastBackground: #3fc3ee;
    }
</style>